import { getNewRefreshToken } from 'api';
import { getSessionStorage, setSessionStorage } from 'assets/constant';
import axios from 'axios';
import { serverErrorHandler } from 'util/api/errorHandler';
import { setCookie } from 'util/cookie';

let isTokenRefreshing = false;
let failedRequestsQueue = [];

export const postDataBodyQuery = async (url, body) => {
  const access = getSessionStorage('accessToken');
  try {
    const response = await axios.post(`${process.env.REACT_APP_SERVER}${url}`, body, {
      headers: {
        Authorization: `Bearer ${access}`,
      },
    });
    // const response = await axios.get(`${process.env.REACT_APP_SERVER}${url}`, config, JSON.parse(jsonBody));

    serverErrorHandler(response);

    const checkT007 = response.data?.errorCode === 'T007';
    const checkExpired = response.data?.errorMessage === 'expired token';

    if (checkT007 && checkExpired) {
      if (!isTokenRefreshing) {
        // 리프레시 중이라면?
        isTokenRefreshing = true;
        const { data } = await getNewRefreshToken();
        const { accessToken, refreshToken } = data;

        setSessionStorage(accessToken);
        setCookie('refreshToken', refreshToken);
        isTokenRefreshing = false;

        // 재시도 실패한 요청
        failedRequestsQueue.forEach((callback) => callback(accessToken));
        failedRequestsQueue = [];
      } else {
        // 새로고침된 토큰 대기열 추가
        const retryRequest = new Promise((resolve, reject) => {
          failedRequestsQueue.push((newToken) => {
            axios
              .get(`${process.env.REACT_APP_SERVER}${url}`, {
                headers: {
                  Authorization: `Bearer ${newToken}`,
                },
              })
              .then((response) => {
                resolve(response);
              })
              .catch((error) => {
                reject(error);
              });
          });
        });

        return retryRequest;
      }
    }
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
